import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import * as auth from "../_redux/authRedux";
import { login } from "../_redux/authCrud";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers/AssetsHelpers";
import SVG from "react-inlinesvg";
import { logInWithEmailAndPassword } from "../../../firebaseHelper";
import { LanguageSelectorDropdown } from "../../../../_metronic/layout/components/extras/dropdowns/LanguageSelectorDropdown";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet";
import preval from "preval.macro";
import moment from "moment";
export const getBuildDate = (epoch) => {
  const buildDate = moment(epoch).format("MM-DD-YYYY");
  return buildDate;
};
/*
  INTL (i18n) docs:
  https://github.com/formatjs/react-intl/blob/master/docs/Components.md#formattedmessage
*/

/*
  Formik+YUP:
  https://jaredpalmer.com/formik/docs/tutorial#getfieldprops
*/

const initialValues = {
  email: "",
  password: "",
};

function Login(props) {
  var url = new URL(window.location.href);
  var userName = url.searchParams.get("username");
  var password = url.searchParams.get("password");

  const today = new Date().getFullYear();
  const [showpassword, setShowpassword] = useState();
  const { intl } = props;
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();
  const LoginSchema = Yup.object().shape({
    email: Yup.string()
      .email(t("Wrong_email_format"))
      .min(3, t("Minimum_3_symbols"))
      .max(50, t("Maximum_50_symbols"))
      .required(t("Email_is_Required")),
    password: Yup.string()
      .min(8, t("Minimum_8_symbols"))
      .max(50, t("Maximum_50_symbols"))
      .required(t("Password_is_Required")),
  });

  const enableLoading = () => {
    setLoading(true);
  };

  const disableLoading = () => {
    setLoading(false);
  };

  const getInputClasses = (fieldname) => {
    if (formik.touched[fieldname] && formik.errors[fieldname]) {
      return "is-invalid";
    }

    if (formik.touched[fieldname] && !formik.errors[fieldname]) {
      return "is-valid";
    }

    return "";
  };
  if (userName !== null && userName !== "null" && userName !== undefined) {
    console.log("userName", userName);
    console.log("password", password);
    console.log("url", url);
    login(userName, password)
      .then(async ({ data: { accessToken } }) => {
        await logInWithEmailAndPassword(
          userName,
          `pass-${userName?.replace(" ", "")}`
        );
        disableLoading();
        props.login(accessToken);
      })
      .then(async () => {
        setTimeout(() => {
          window.location.href = "http://localhost:8000/";
        }, 500);
      })
      .catch(() => {
        disableLoading();
      });
  }
  const formik = useFormik({
    initialValues,
    validationSchema: LoginSchema,
    onSubmit: (values, { setStatus, setSubmitting }) => {
      enableLoading();
      setTimeout(() => {
        login(values.email, values.password)
          .then(async ({ data: { accessToken } }) => {
            await logInWithEmailAndPassword(
              values.email,
              `pass-${values.email?.replace(" ", "")}`
            );
            disableLoading();
            props.login(accessToken);
          })
          .catch(() => {
            disableLoading();
            setSubmitting(false);
            setStatus(
              intl.formatMessage({
                id: "AUTH.VALIDATION.INVALID_LOGIN",
              })
            );
          });
      }, 1000);
    },
  });

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Shipper | {t("Login")}</title>
      </Helmet>
      <div
        className="login login-3 login-signin-on d-flex flex-row-fluid"
        id="kt_login"
      >
        <div
          className="flex-center bgi-size-cover bgi-no-repeat flex-row-fluid"
          style={{ backgroundImage: "url(/media/bg/login.jpg)" }}
        >
          <div className="position-fixed top-0 end-0 m-5 Zindex-1">
            <LanguageSelectorDropdown />
          </div>
          <div className="col-xl-4 col-lg-5 col-md-10 col-12  p-7 position-relative overflow-hidden mx-auto">
            {/*begin::Login Header*/}
            {/*end::Login Header*/}
            {/*begin::Login Sign in form*/}
            <div className="card card-custom bg-transparent rounded">
              <div className="card-header card-header-tabs-line">
                <div className="d-flex flex-center flex-column mt-7 mx-auto">
                  <p className="mb-10">
                    <SVG
                      src={toAbsoluteUrl(
                        "/media/svg/logos/Full-Color_-RGB_Vertical.svg"
                      )}
                    />
                  </p>
                  <div className="text-center mb-7">
                    <h3>{t("SignIn_eMPower")}</h3>
                    <div className="text-white  font-weight-bold">
                      <span className="">{t("New_Here")}?</span>
                      <Link
                        to="/auth/Registration"
                        id="kt_login_signup"
                        className="font-weight-bolder text-info pl-1"
                      >
                        {t("Create_an_Account")}
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
              <div className="card-body">
                <div className="login-signin">
                  <form
                    onSubmit={formik.handleSubmit}
                    className="form fv-plugins-bootstrap fv-plugins-framework"
                  >
                    <div className="form-group mb-5 pull-left">
                      <label className="control-label font-weight-bold text-white">
                        {t("Email")}
                      </label>
                      <input
                        placeholder={t("Email")}
                        type="email"
                        className={`form-control form-control-solid h-auto py-5 px-6 ${getInputClasses(
                          "email"
                        )}`}
                        name="email"
                        {...formik.getFieldProps("email")}
                      />
                      {formik.touched.email && formik.errors.email ? (
                        <div className="fv-plugins-message-container">
                          <div className="fv-help-block">
                            {formik.errors.email}
                          </div>
                        </div>
                      ) : null}
                    </div>
                    <div className="form-group mb-5">
                      <div className=" d-flex flex-wrap justify-content-between ">
                        <label className="control-label font-weight-bold text-white">
                          {t("Password")}
                        </label>
                        <Link
                          to="/auth/forgot-password"
                          className="text-info text-hover-info font-weight-bolder  mr-2"
                          id="kt_login_forgot"
                        >
                          {t("Forgotten_Password")} ?
                        </Link>
                      </div>
                      <div className="position-relative mb-3">
                        <input
                          placeholder={t("Password")}
                          type={showpassword ? "text" : "password"}
                          className={`form-control form-control-solid h-auto py-5 px-6 ${getInputClasses(
                            "password"
                          )}`}
                          name="password"
                          {...formik.getFieldProps("password")}
                        />
                        <div className="position-absolute translate-middle-c top-50 end-0 mr-3">
                          <span
                            className="svg-icon svg-icon-2hx"
                            onClick={() =>
                              setShowpassword(showpassword ? false : true)
                            }
                          >
                            <img
                              src={toAbsoluteUrl(
                                showpassword
                                  ? "/media/svg/icons/General/Visible.svg"
                                  : "/media/svg/icons/General/Hidden.svg"
                              )}
                              alt=""
                              className="h-25px"
                            />
                          </span>
                        </div>
                      </div>
                      {formik.touched.password && formik.errors.password ? (
                        <div className="fv-plugins-message-container">
                          <div className="fv-help-block">
                            {formik.errors.password}
                          </div>
                        </div>
                      ) : null}
                    </div>
                    <div className="text-center">
                      <button
                        id="kt_login_signin_submit"
                        className="btn  btn-info font-weight-bold px-9 py-4 my-3 mx-4"
                        type="submit"
                        disabled={formik.isSubmitting}
                      >
                        <span>{t("Sign_In")}</span>
                        {loading && (
                          <span className="ml-3 spinner spinner-white"></span>
                        )}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
              {/*end::Login Sign in form*/}
            </div>
          </div>
          <div
            className={`footer bg-transparente py-4 d-flex flex-lg-column  bottom-0 w-100`}
            id="kt_footer"
          >
            {/* begin::Container */}
            <div
              className={`container-fluid d-flex flex-column flex-md-row align-items-center justify-content-between `}
            >
              {/* begin::Copyright */}
              <div className="text-dark order-2 order-md-1">
                <span className="text-white font-weight-bold mr-2">
                  {today} &copy;
                </span>
                {` `}
                <a
                  href="/auth/login"
                  rel="noopener noreferrer"
                  target="_blank"
                  className="text-white text-hover-primary"
                >
                  Shipper
                </a>
                <span className="text-white mr-2">
                  Build Version{" "}
                  <a
                    href={() => false}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="font-weight-bolder text-white"
                  >
                    {window.$appVersion}
                  </a>{" "}
                  / Build Date:{" "}
                  <strong>{preval`module.exports = new Date().toLocaleDateString("en-US");`}</strong>
                  .
                </span>
              </div>
              {/* end::Copyright */}
              {` `}
              {/* begin::Nav */}
              <div className="nav nav-dark order-1 order-md-2">
                <Link
                  to="/privacy-policy"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="nav-link pr-3 pl-0 text-white"
                >
                  {t("Privacy_Policy")}
                </Link>
                <span className="nav-link px-3 text-white">{t("Support")}</span>
                <Link
                  to="/faq"
                  rel="noopener noreferrer"
                  className="nav-link pl-3 pr-0 text-white"
                >
                  FAQ
                </Link>
              </div>
              {/* end::Nav */}
            </div>
            {/* end::Container */}
          </div>
        </div>
        {/*end::Login*/}
      </div>
    </>
  );
}

export default injectIntl(connect(null, auth.actions)(Login));
